import {
  DebtResponsible,
  DisabilityPension,
  EconomicalHealthWish,
  EconomicalSituation,
  Education,
  FamilySituation,
  WorkSituation,
} from "./interfaces";

import { Option as IOption } from "@storeblocks/radio";
import { Option } from "@storeblocks/select";
import { Option as TrueFalseOption } from "Components/Form/RadioButton/RadioButtonTrueFalse";

export const getFamilySituationOptions = (
  options: any,
  lang: string,
): Option[] => [
  {
    label: options.defaultLabel[lang],
    value: "",
  },
  {
    label: options.married[lang],
    value: FamilySituation.MARRIED,
  },
  {
    label: options.cohabitant[lang],
    value: FamilySituation.COHABITANT,
  },
  {
    label: options.single[lang],
    value: FamilySituation.SINGLE,
  },
];

export const getWorkSituationOptions = (
  options: any,
  lang: string,
): Option[] => [
  {
    label: options.defaultLabel[lang],
    value: "",
  },
  {
    label: options.workPrivate[lang],
    value: WorkSituation.WORK_PRIVATE,
  },
  {
    label: options.workPublic[lang],
    value: WorkSituation.WORK_PUBLIC,
  },
  {
    label: options.selfEmployed[lang],
    value: WorkSituation.SELF_EMPLOYED,
  },
  {
    label: options.fullTimeStudent[lang],
    value: WorkSituation.FULL_TIME_STUDENT,
  },
  {
    label: options.notWorking[lang],
    value: WorkSituation.NOT_WORKING,
  },
  {
    label: options.pensioner[lang],
    value: WorkSituation.PENSIONER,
  },
];

export const getEducationOptions = (options: any, lang: string): Option[] => [
  {
    label: options.defaultLabel[lang],
    value: "",
  },
  {
    label: options.highSchoolPlus5Years[lang],
    value: Education.HIGH_SCHOOL_PLUS_5_YEARS,
  },
  {
    label: options.highSchoolPlus3Years[lang],
    value: Education.HIGH_SCHOOL_PLUS_3_YEARS,
  },
  {
    label: options.highSchool[lang],
    value: Education.HIGH_SCHOOL,
  },
  {
    label: options.notHighSchool[lang],
    value: Education.NOT_HIGH_SCHOOL,
  },
];

export const getIncomeDependencyOptions = (
  options: any,
  lang: string,
): TrueFalseOption[] => [
  {
    label: options.yes[lang],
    value: true,
    id: "incomeDependency-yes",
  },
  {
    label: options.no[lang],
    value: false,
    id: "incomeDependency-no",
  },
];

export const getDebtResponsibleOptions = (
  familySituation: FamilySituation,
  options: any,
  lang: string,
): IOption[] => [
  {
    label: options.both[lang],
    value: DebtResponsible.BOTH,
    id: DebtResponsible.BOTH,
  },
  {
    label: options.meAlone[lang],
    value: DebtResponsible.ME_ALONE,
    id: DebtResponsible.ME_ALONE,
  },
  {
    label:
      familySituation === FamilySituation.MARRIED
        ? options.spouseCohabitantAlone.spouse[lang]
        : options.spouseCohabitantAlone.cohabitant[lang],
    value: DebtResponsible.SPOUSE_COHABITANT_ALONE,
    id: DebtResponsible.SPOUSE_COHABITANT_ALONE,
  },
];

export const getDisabilityPensionOptions = (
  options: any,
  lang: string,
): Option[] => [
  {
    label: options.defaultLabel[lang],
    value: "",
  },
  {
    label: options.no[lang],
    value: DisabilityPension.NO,
  },
  {
    label: options.yes[lang],
    value: DisabilityPension.YES,
  },
  {
    label: options.doNotKnow[lang],
    value: DisabilityPension.DO_NOT_KNOW,
  },
];

export const getEconomicalSituationOptions = (
  options: any,
  lang: string,
): IOption[] => [
  {
    label: options.spacious[lang],
    value: EconomicalSituation.SPACIOUS,
    id: `economicalSituation-${EconomicalSituation.SPACIOUS}`,
  },
  {
    label: options.justRight[lang],
    value: EconomicalSituation.JUST_RIGHT,
    id: `economicalSituation-${EconomicalSituation.JUST_RIGHT}`,
  },
  {
    label: options.tight[lang],
    value: EconomicalSituation.TIGHT,
    id: `economicalSituation-${EconomicalSituation.TIGHT}`,
  },
];

export const getEconomicalHealthWishOptions = (
  options: any,
  lang: string,
): IOption[] => [
  {
    label: options.financesLikeToday[lang],
    value: EconomicalHealthWish.FINANCES_LIKE_TODAY,
    id: `economicalHealthWish-${EconomicalHealthWish.FINANCES_LIKE_TODAY}`,
  },
  {
    label: options.slightEconomicDownturn[lang],
    value: EconomicalHealthWish.SLIGHT_ECONOMIC_DOWNTURN,
    id: `economicalHealthWish-${EconomicalHealthWish.SLIGHT_ECONOMIC_DOWNTURN}`,
  },
  {
    label: options.significantEconomicDownturn[lang],
    value: EconomicalHealthWish.SIGNIFICANT_ECONOMIC_DOWNTURN,
    id: `economicalHealthWish-${EconomicalHealthWish.SIGNIFICANT_ECONOMIC_DOWNTURN}`,
  },
];
